import { create } from "zustand";

type SettingsStore = {
  price: number | null;
  sale: number | null;
  disabled: boolean;
  setField: (field: string, value: unknown) => void;
  reset: () => void;
};

const useSettingsStore = create<SettingsStore>((set) => ({
  disabled: false,
  price: null,
  sale: null,
  setField: (field, value) => set({ [field]: value }),
  reset: () => set({ price: null, sale: null, disabled: false }),
}));

export default useSettingsStore;
